import { REGEX } from '../../../../constants/regex';

export const commonValidValues = ['+'];

const defaultMask = '___ ___ ____';

export const defaultMaskWithoutPrefix = defaultMask;

export const regexRuleWithoutPrefix = REGEX.MSISDN_WITHOUT_PREFIX;

export const charsValidation = REGEX.NUMBER_ONLY;

export const defaultLabel = 'Phone number';

// MSISDN VALIDATION RULES FOR: NIGERIA

export const partialDefaultPrefix = '234';
export const defaultPrefix = `+${partialDefaultPrefix}`;

export const helperValidExample = `${defaultPrefix} 123 456 7890`;

export const regexRuleWithPrefix = REGEX.MSISDN_WITH_PREFIX;

export const defaultMaskWithPrefix = `${defaultPrefix} ${defaultMask}`;
